import { HISTORY_TYPE, IHistoryStep, ILanding } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";

export default function undo() {
    const currentLanding: ILanding      = useLandingStore.getState().currentLanding
    const history: IHistoryStep[]       = useLandingStore.getState().history
    const currentHistoryStep: number    = useLandingStore.getState().currentHistoryStep
    const step                          = history[ currentHistoryStep ]
    
    if(!step) {
        return
    }

    switch(step.type) {
        case HISTORY_TYPE.SECTION:
            if(!!step.prevData) {
                const newLanding: ILanding = {
                    ...currentLanding,
                    sections: currentLanding.sections.map((section, i) => {
                        if( step.prevData.id === section.id ) {
                            return step.prevData;
                        }
                        return section;
                    })
                }
                useLandingStore.setState({ 
                    currentLanding: newLanding, 
                    currentHistoryStep: currentHistoryStep + 1 
                })
            }
            break
        case HISTORY_TYPE.SETTINGS:
        default:
            return
    }
}